export const LedgerTypes = [
  // note: valueは各APIのエンドポイントにリンクしている
  {
    text: 'order.order_order',
    value: 'order',
    line1: [
      'orderDate',
      'supplier',
      'displayMethod',
      'adjustmentAmountDisplay'
    ],
    line2: ['orderStatusId', 'orderPaymentStatusId', 'loadingStatusId'],
    line3: ['supplier', 'author', 'product', 'quantity', 'code'],
    displayMethods: ['normal', 'taxRate'],
    adjustmentAmountDisplay: ['summarize', 'separate'],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'loading.loading_loading',
    value: 'loading',
    line1: ['orderDate', 'supplier', 'adjustmentAmountDisplay'],
    line2: ['loadingStatusId'],
    line3: ['purchase', 'author', 'product', 'quantity', 'code'],
    displayMethods: [],
    adjustmentAmountDisplay: ['summarize', 'separate'],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'storage.storage_payment-exe',
    value: 'order-payment',
    line1: ['orderDate', 'supplier'],
    line2: ['orderPaymentStatusId'],
    line3: ['supplier', 'author', 'orderPayment', 'exchange'],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'sale.sale_sale',
    value: 'sale',
    line1: [
      'orderDate',
      'supplier',
      'customers',
      'displayMethod',
      'adjustmentAmountDisplay'
    ],
    line2: ['saleStatusId', 'salePaymentStatusId', 'shipStatusId'],
    line3: [
      'customer',
      'taxRate',
      'author',
      'exportSubjectFlg',
      'purchase',
      'quantity',
      'code',
      'cost',
      'product'
    ],
    displayMethods: ['normal', 'taxRateExportEntity'],
    adjustmentAmountDisplay: ['summarize', 'separate'],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'ship.ship_ship',
    value: 'ship',
    line1: ['orderDate', 'supplier', 'customers', 'adjustmentAmountDisplay'],
    line2: ['shipStatusId'],
    line3: [
      'customer',
      'taxRate',
      'author',
      'exportSubjectFlg',
      'purchase',
      'quantity',
      'code',
      'cost',
      'product'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: ['summarize', 'separate'],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'payment.payment_sale-payment',
    value: 'sale-payment',
    line1: ['orderDate', 'supplier', 'customers'],
    line2: ['salePaymentStatusId'],
    line3: ['customer', 'author', 'salePayment', 'exchange'],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'common.refund_refund',
    value: 'refund',
    line1: [
      'orderDate',
      'supplier',
      'customers',
      'displayMethod',
      'adjustmentAmountDisplay'
    ],
    line2: [],
    line3: [
      'refundCustomer',
      'taxRate',
      'author',
      'exportSubjectFlg',
      'purchase',
      'quantity',
      'code',
      'cost',
      'product'
    ],
    displayMethods: ['normal', 'taxRateExportEntity'],
    adjustmentAmountDisplay: ['summarize', 'separate'],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'common.common_storage-move',
    value: 'storage-move',
    line1: ['orderDate', 'shipStorage', 'loadingStorage'],
    line2: ['storageMoveStatusId'],
    line3: [
      'loadingStorageName',
      'author',
      'code',
      'product',
      'purchase',
      'quantity'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: false,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'common.common_stock-adjust',
    value: 'stock-adjust',
    line1: ['orderDate', 'adjustStorage'],
    line2: [],
    line3: [
      'storageName',
      'author',
      'adjustReason',
      'target',
      'code',
      'product',
      'purchase',
      'quantity'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: false,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'jd.jd_jdcom-month-end-stock',
    value: 'month-end-stock',
    line1: ['orderMonth', 'storage', 'supplier'],
    line2: [],
    line3: [
      'purchase',
      'product',
      'code',
      'taxRate',
      'stock',
      'shipmentIncompleteQuantity',
      'loadIncompleteQuantity',
      'totalQuantity'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: true
  },
  {
    text: 'jd.jd_jdcom-cost-floating-table',
    value: 'cost-floating-table',
    line1: ['orderDate', 'supplier'],
    line2: [],
    line3: [
      'purchase',
      'product',
      'quantity',
      'code',
      'originalCost',
      'actualCost',
      'costDifference'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: false,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'jd.jd_jdcom-income-statement',
    value: 'income-statement',
    line1: ['orderDate', 'supplier', 'customers'],
    line2: [],
    line3: [
      'orderAmount',
      'saleAmount',
      'notPaidOrderAmount',
      'notPaidSaleAmount',
      'productCost'
    ],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: true,
    isShowHideUnusedProductCheck: false
  },
  {
    text: 'sale.sale_combined-bill-list',
    value: 'combined-bill',
    line1: ['createDate', 'billDate', 'customers', 'currency', 'amount'],
    line2: [],
    line3: [],
    displayMethods: [],
    adjustmentAmountDisplay: [],
    isShowHideUnusedCurrencyCheck: false,
    isShowHideUnusedProductCheck: false
  }
]

export const LedgerInfoLine1Items = [
  {
    text: 'common.common_target-period',
    name: 'orderDate'
  },
  {
    text: 'common.common_target-month',
    name: 'orderMonth'
  },
  {
    text: 'product.product_supplier',
    name: 'supplier',
    param: 'supplierIds'
  },
  {
    text: 'sale.sale_customer',
    name: 'customers',
    param: 'customerIds'
  },
  {
    text: 'common.common_display-method',
    name: 'displayMethod',
    param: 'displayMethod'
  },
  {
    text: 'ship.ship_ship-storage',
    name: 'shipStorage',
    param: 'shipStorageIds'
  },
  {
    text: 'loading.loading_loading-storage',
    name: 'loadingStorage',
    param: 'loadingStorageIds'
  },
  {
    text: 'stock-adjust.stock-adjust_stock-adjust_adjustment-warehouse',
    name: 'adjustStorage',
    param: 'adjustStorageIds'
  },
  {
    text: 'common.common_storage',
    name: 'storage',
    param: 'storageIds'
  },
  {
    text: 'common.common_adjust-price',
    name: 'adjustmentAmountDisplay',
    param: 'adjustmentAmountDisplay'
  },
  {
    text: 'common.common_hide-unused-products',
    name: 'isShowHideUnusedProductCheck'
  },
  {
    text: 'common.common_create-day',
    name: 'createDate'
  },
  {
    text: 'sale.sale_bill-date',
    name: 'billDate'
  },
  {
    text: 'common.input_currency',
    name: 'currency'
  },
  {
    text: 'payment.payment_total-price-no-colon',
    name: 'amount'
  },
]

export const LedgerInfoLine2Items = [
  // note: nameを各APIのパラメータ名にする
  {
    text: 'order.order_order-status',
    name: 'orderStatusId',
    component: 'SelectStatusForLedgerSheet'
  },
  {
    text: 'sale.sale_payment-status',
    name: 'orderPaymentStatusId',
    component: 'SelectStatusForLedgerSheet',
    type: 1
  },
  {
    text: 'order.order_loading-status',
    name: 'loadingStatusId',
    component: 'SelectStatusForLedgerSheet'
  },
  {
    name: 'salePaymentStatusId',
    text: 'sale.sale_sale-payment-status',
    component: 'SelectStatusForLedgerSheet',
    type: 1
  },
  {
    name: 'shipStatusId',
    text: 'sale.ship_ship-status',
    component: 'SelectStatusForLedgerSheet'
  },
  {
    name: 'saleStatusId',
    text: 'sale.sale_sale-status',
    component: 'SelectStatusForLedgerSheet'
  },
  {
    text: 'stock-move.stock-move_storage-move-status',
    name: 'storageMoveStatusId',
    component: 'SelectStatusForLedgerSheet',
    type: 2
  }
]

export const LedgerInfoLine3Items = [
  {
    text: 'order.order_order-supplier',
    name: 'supplier',
    param: 'shouldShowOrderSupplierName'
  },
  {
    // note: 画面には「仕入先」と出すがAPIには「発注先」へ繋ぐもの
    text: 'product.product_supplier',
    name: 'purchase',
    param: 'shouldShowSupplierName'
  },
  {
    text: 'sale.sale_customer-name',
    name: 'customer',
    param: 'shouldShowCustomerName'
  },
  {
    text: 'refund.refund_refund-customer',
    name: 'refundCustomer',
    param: 'shouldShowRefundCustomerName'
  },
  {
    text: 'common.product_product-name',
    name: 'product',
    param: 'shouldShowProductName'
  },
  {
    text: 'sale.sale_author',
    name: 'author',
    param: 'shouldShowUserName'
  },
  {
    text: 'common.common_quantity',
    name: 'quantity',
    param: 'shouldShowQuantity'
  },
  {
    text: 'common.common_product-code',
    name: 'code',
    param: 'shouldShowProductNumber'
  },
  {
    text: 'sale.sale_payment-status',
    name: 'orderPayment',
    param: 'shouldShowOrderPaymentStatus'
  },
  {
    text: 'sale.sale_sale-payment-status',
    name: 'salePayment',
    param: 'shouldShowSalePaymentStatus'
  },
  {
    text: 'common.common_exchange-loss',
    name: 'exchange',
    param: 'shouldShowExchangeLoss'
  },
  {
    text: 'common.product_consumption-tax-rate',
    name: 'taxRate',
    param: 'shouldShowTaxRate'
  },
  {
    text: 'sale.sale_exporter',
    name: 'exportSubjectFlg',
    param: 'shouldShowExportSubjectFlg'
  },
  {
    text: 'common.common_cost-difference',
    name: 'cost',
    param: 'shouldShowCost'
  },
  {
    text: 'loading.loading_loading-storage',
    name: 'loadingStorageName',
    param: 'shouldShowLoadingStorageName'
  },
  {
    text: 'common.common_storage',
    name: 'storageName',
    param: 'shouldShowStorageName'
  },
  {
    text: 'common.common_storage',
    name: 'stock',
    param: 'shouldShowStock'
  },
  {
    text: 'stock-adjust.stock-adjust_stock-adjust-reason',
    name: 'adjustReason',
    param: 'shouldShowAdjustReason'
  },
  {
    text: 'common.common_target',
    name: 'target',
    param: 'shouldShowTarget'
  },
  {
    text: 'order.order_ordered-and-unshipped-no-asterisk',
    name: 'shipmentIncompleteQuantity',
    param: 'shouldShowShipmentIncompleteQuantity'
  },
  {
    text: 'order.order_ordered-undelivered-no-asterisk',
    name: 'loadIncompleteQuantity',
    param: 'shouldShowLoadIncompleteQuantity'
  },
  {
    text: 'storage.stock_all-stock',
    name: 'totalQuantity',
    param: 'shouldShowTotalQuantity'
  },
  {
    text: 'common.common_original-cost',
    name: 'originalCost',
    param: 'shouldShowOriginalCost'
  },
  {
    text: 'common.common_actual-cost',
    name: 'actualCost',
    param: 'shouldShowActualCost'
  },
  {
    text: 'common.common_cost-difference',
    name: 'costDifference',
    param: 'shouldShowCostAmountDifference'
  },
  {
    text: 'order.order_order-amount',
    name: 'orderAmount',
    param: 'shouldShowOrderAmount'
  },
  {
    text: 'sale.sale_sale-amount',
    name: 'saleAmount',
    param: 'shouldShowSaleAmount'
  },
  {
    text: 'storage.storage_not-payment-price-no-colon',
    name: 'notPaidOrderAmount',
    param: 'shouldShowNotPaidOrderAmount'
  },
  {
    text: 'payment.payment_unpaid-price',
    name: 'notPaidSaleAmount',
    param: 'shouldShowNotPaidSaleAmount'
  },
  {
    text: 'common.common_product-cost',
    name: 'productCost',
    param: 'shouldShowProductCost'
  }
]

export const DisplayMethodItems = [
  {
    text: 'common.common_display-normal',
    name: 'normal',
    value: 1
  },
  {
    text: 'common.common_display-tax-rate',
    name: 'taxRate',
    value: 2
  },
  {
    text: 'common.common_display-tax-rate-export-entity',
    name: 'taxRateExportEntity',
    value: 2
  }
]

export const AdjustmentAmountDisplayItems = [
  {
    text: 'common.common_display-collectively-transaction',
    name: 'summarize',
    value: 1
  },
  {
    text: 'common.common_display-proportionally-product',
    name: 'separate',
    value: 2
  }
]

export default {
  LedgerTypes,
  LedgerInfoLine1Items,
  LedgerInfoLine2Items,
  LedgerInfoLine3Items,
  DisplayMethodItems,
  AdjustmentAmountDisplayItems
}
